module.exports = __webpack_public_path__ + "img/icon-helder-transparant.54294b3c600dd5230ed0458bc75b9324.svg";